import { Route } from '@angular/router';
import { RenderMode, ServerRoute } from '@angular/ssr';

export const authActionRouteServer: ServerRoute = {
  path: 'auth/action',
  renderMode: RenderMode.Client,
};

export const authActionRouteClient: Route = {
  path: 'auth/action',
  pathMatch: 'full',
  loadComponent: () =>
    import('../../pages/auth-action/auth-action.component').then(
      (c) => c.AuthActionComponent
    ),
};
